<div class="footer-wrapper">
  <div class="container footer-inner">
    <footer class="footer-container">
      <div class="grid footer-sub-container m-0">
        <div class="col-12 md:col-6 flex flex-column gap-4 pr-0 md:pr-5">
          <div class="footer-logo">
            <a [href]="homeHref" class="inline-block">
              <img
                src="assets/images/logo.svg"
                alt="Divinea"
                width="140"
                height="48"
                class="footer-divinea-logo"
              />
            </a>
          </div>
          <p class="footer-description m-0 line-height-3">
            {{ 'FOOTER.DESCRIPTION' | translate }}
          </p>

          <div class="flex flex-column gap-3">
            <h2 class="footer-heading m-0">{{ 'FOOTER.INFORMATION' | translate }}</h2>
            <ul class="footer-link-list list-none p-0 m-0 flex flex-column gap-2">
              <li>
                <a href="#" class="footer-link">{{ 'FOOTER.PRIVACY_POLICY' | translate }}</a>
              </li>
              <li>
                <a href="#" class="footer-link">{{ 'FOOTER.TERMS_CONDITIONS' | translate }}</a>
              </li>
              <li>
                <a href="#" class="footer-link">{{ 'FOOTER.COOKIE_MANAGEMENT' | translate }}</a>
              </li>
            </ul>
          </div>

          <div class="flex flex-column gap-3">
            <h2 class="footer-heading m-0">{{ 'FOOTER.CONTACTS' | translate }}</h2>
            <ul class="footer-link-list list-none p-0 m-0 flex flex-column gap-2">
              <li>
                <a href="#" class="footer-link">{{ 'FOOTER.CONTACT_US' | translate }}</a>
              </li>
              <li>
                <a href="#" class="footer-link">{{ 'FOOTER.SUPPORT' | translate }}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 md:col-6 flex flex-column gap-4 pl-0 md:pl-5">
          <section class="flex flex-column gap-3 w-full">
            <h2 class="footer-heading m-0">{{ 'FOOTER.NEWSLETTER' | translate }}</h2>
            <input
              pInputText
              id="footer-email"
              class="w-full footer-input"
              [(ngModel)]="email"
              [placeholder]="'FOOTER.EMAIL_PLACEHOLDER' | translate"
              autocomplete="email"
              aria-describedby="footer-email-help"
            />
            <div class="flex align-items-start gap-2">
              <p-checkbox
                [(ngModel)]="checked"
                [binary]="true"
                inputId="footer-privacy"
                styleClass="footer-checkbox"
              />
              <label for="footer-privacy" class="footer-checkbox-label line-height-3 m-0 cursor-pointer">
                {{ 'FOOTER.ACCEPT_PRIVACY' | translate }}
              </label>
            </div>
            <a class="footer-btn-iscriviti inline-block text-center white-space-nowrap" href="#">
              {{ 'FOOTER.SUBSCRIBE' | translate }}
            </a>
          </section>

          <p-divider styleClass="footer-divider" />

          <section class="flex flex-column gap-3 align-items-start w-full contattaci-footer">
            <h2 class="footer-heading m-0">{{ 'FOOTER.ARE_YOU_WINERY' | translate }}</h2>
            <img
              src="https://wine-suite.com/wp-content/uploads/2022/07/wine-suite-white.svg"
              alt="Wine Suite"
              width="114"
              height="36"
              class="footer-wine-suite-logo"
              loading="lazy"
            />
            <a class="footer-btn-contattaci inline-block text-center white-space-nowrap" href="/contatti/">
              {{ 'FOOTER.CONTACT_US' | translate }}
            </a>
          </section>
        </div>
      </div>
    </footer>
  </div>

  <div class="footer-bottom">
    <div class="container">
      <div class="footer-bottom-inner flex flex-column md:flex-row flex-wrap align-items-center justify-content-between gap-4">
        <div class="footer-bottom-text text-center md:text-left">
          {{ 'FOOTER.COPYRIGHT' | translate }}
        </div>
        <div class="social-icons flex flex-row align-items-center justify-content-center gap-2">
          <a href="#" class="social-circle flex align-items-center justify-content-center" aria-label="Instagram">
            <i class="pi pi-instagram"></i>
          </a>
          <a href="#" class="social-circle flex align-items-center justify-content-center" aria-label="Facebook">
            <i class="pi pi-facebook"></i>
          </a>
          <a href="#" class="social-circle flex align-items-center justify-content-center" aria-label="LinkedIn">
            <i class="pi pi-linkedin"></i>
          </a>
          <a href="#" class="social-circle flex align-items-center justify-content-center" aria-label="YouTube">
            <i class="pi pi-youtube"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
